module.exports = __webpack_public_path__ + "img/couples-048.de5f55ba.jpg";